module.exports = __webpack_public_path__ + "img/img-badge-009-off@3x.b624c931.png";